export enum TaskViewActionTypes {
  GET_TASKS = 'GET_TASKS',
  GET_TASKS_ALL = 'GET_TASKS_ALL',
  CLAIM_TASK = 'CLAIM_TASK',
  REJECT_TASK = 'REJECT_TASK',
  QUICK_REJECT_TASK = 'QUICK_REJECT_TASK',
  UN_CLAIM_TASK = 'UN_CLAIM_TASK',
  SET_TASKS_LOADING = 'SET_TASKS_LOADING',
  GET_NEW_TASKS_COUNT = 'GET_NEW_TASKS_COUNT',
  GET_NEW_TASKS_ALL_COUNT = 'GET_NEW_TASKS_ALL_COUNT',
}
